import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Paper, Tabs, Tab, Grid} from '@material-ui/core'
import {compose} from 'redux'
import Page from 'src/shared/Page/Page'
import autobind from 'autobind-decorator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { sizeCotations } from 'src/core/redux/action/cotationsAction'
import { css } from 'src/conf/style'
import CotationsTable from 'src/page/Consumer/Cotations/CotationsTable'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import PageTitle from 'src/shared/PageTitle/PageTitle'
import { ActionsBar } from 'src/shared/ActionsBar/ActionsBar'
import { withRouter, RouteComponentProps } from 'react-router'
import Btn from 'src/shared/Btn/Btn'

const styles = (t: Theme) => createStyles({
    root: {
        position: 'relative',
        flexGrow: 1,
        paddingTop: t.spacing.unit,
        padding: t.spacing.unit * 4,
        backgroundColor: t.palette.background.paper,
    },
    tabsRoot: {
        marginBottom: t.spacing.unit * 4,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    tabSelected: {

    },
    tabLbl: {
        ...css.flexFullCenter
    },
    badge: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: t.palette.primary.main,
        marginLeft: '.75rem',
        minWidth: '20px'
    },
    badge2: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: 'rgb(63,81,181)',
        marginLeft: '.75rem',
        minWidth: '20px'
    }
});


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  RouteComponentProps<any> {
}

interface IStates {
    totalCotationDone: number | undefined;
    totalCotationExpired: number | undefined;
    totalCotationLive: number | undefined;
    tabActive: number;
}

class Cotations extends React.Component<IProps, IStates> {
    state = {
        tabActive: 0,
        totalCotationDone:undefined,
        totalCotationExpired: undefined,
        totalCotationLive: undefined
    };

  render(){
    const { t, classes } = this.props;
    const { tabActive, totalCotationLive, totalCotationExpired, totalCotationDone } = this.state;
    return(
        <>
            
            <HelmetMeta title={t.App_title_page_Cotations}/>
            <PageTitle title={t.cotations} icon="record_voice_over" />
            
            <Page width="80%">
            <Paper className={classes.root}>
                <ActionsBar>
                    <Btn
                        color='primary'
                        icon='record_voice_over'
                        variant='contained'
                        id="btn-cotation"
                        onClick={this.requestCotation}
                    >
                        {t.ask_cotation}
                    </Btn>
                </ActionsBar>
                {totalCotationLive !== undefined && totalCotationExpired !== undefined && totalCotationDone !== undefined &&
                    <Grid container>
                        <Grid item xs={12}>
                            <Tabs
                            value={tabActive}
                            onChange={this.handleChange}
                            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                            scrollable scrollButtons="off"
                            >
                                {[
                                    {label: t.Cotation_table_first_tab_lbl, class: classes.badge, size: totalCotationLive}, 
                                    {label: t.Cotation_table_second_tab_lbl, class: classes.badge2, size: totalCotationExpired},
                                    {label: t.Cotation_table_third_tab_lbl, class: classes.badge2, size: totalCotationDone},
                                ].map(tb => (
                                    <Tab
                                        disableRipple
                                        classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                        label={
                                            <div className={classes.tabLbl}>
                                                {tb.label}
                                                <div className={tb.class}>{tb.size}</div>
                                            </div>
                                        }
                                    />
                                ))}
                            </Tabs>

                            {tabActive === 0 &&
                                <CotationsTable status="LIVE" refeshAfterChange={this.refeshSizeTable} />
                            }
                            {tabActive === 1 &&
                                <CotationsTable status="EXPIRED" refeshAfterChange={this.refeshSizeTable}/>
                            }
                            {tabActive === 2 &&
                                <CotationsTable status="DONE" refeshAfterChange={this.refeshSizeTable}/>
                            }
                        </Grid>
                    </Grid>
                }
                </Paper>
            </Page>
       </>
    )
  }

  componentDidMount(){
    const {promisesWithProgress} = this.props
    promisesWithProgress(
        this.props.fetchSize("LIVE").then(res => this.setState({totalCotationLive: res.total_size})),
        this.props.fetchSize("EXPIRED").then(res => this.setState({totalCotationExpired: res.total_size})),
        this.props.fetchSize("DONE").then(res => this.setState({totalCotationDone: res.total_size}))
    )
  }

  refeshSizeTable = () => {
    this.props.fetchSize("LIVE").then(res => this.setState({totalCotationLive: res.total_size}))
    this.props.fetchSize("EXPIRED").then(res => this.setState({totalCotationExpired: res.total_size}))
    this.props.fetchSize("DONE").then(res => this.setState({totalCotationDone: res.total_size}))
  }

  @autobind
  private requestCotation() {
    this.props.history.push(`/ptf/enterprise/${this.props.enterprise.id}/products`)
  }

  @autobind
  private handleChange(event, value) {
    this.setState({ tabActive: value });
  };
}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
});

const dispatch2props = dispatch => ({
    fetchSize: (status: string) => dispatch(sizeCotations(status)),
});


export default compose(
  withI18n,
  withGlobalProgress,
  withRouter,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Cotations)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotations/Cotations.tsx